import { render, staticRenderFns } from "./list-hibah-client.vue?vue&type=template&id=435b47ae&"
import script from "./list-hibah-client.vue?vue&type=script&lang=js&"
export * from "./list-hibah-client.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports